import React from 'react';
import { motion } from 'framer-motion';
import { Check, Heart, ExternalLink } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
import { Card } from '../components/ui/Card';
const paymentMethods = [{
  name: 'Venmo',
  handle: '@threedovespodcast',
  qrImage: 'https://cdn.magicpatterns.com/uploads/sFMnfoUFW31LjM11iTc9HE/venmo.jpg',
  url: 'https://venmo.com/threedovespodcast',
  color: '#008CFF'
}, {
  name: 'Cash App',
  handle: '',
  qrImage: 'https://cdn.magicpatterns.com/uploads/8CSpoX9KqzjAg2qpDX5DCC/cashapp.jpg',
  url: '',
  color: '#00D632'
}];
export function DonatePage() {
  return <PageTransition data-id="element-233" data-mp="2oxhu6x32bgwd">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-234" data-mp="2owyc9gdewsic">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235" data-mp="2ow6lciurfiye">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-16" data-id="element-236" data-mp="2162m0nolu5d7">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-237" data-mp="nwd8h0irf5ba">
              Support the Mission
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-238" data-mp="soo9y7t5ez5y">
              Your generosity fuels honest conversations, real stories, and
              tangible outreach to those in need.
            </p>
          </motion.div>

          {/* How to Give Instructions */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="max-w-2xl mx-auto text-center mb-12 bg-dark-800 rounded-xl p-6 border border-dark-600" data-id="element-239" data-mp="4yk7w4vlz7h2">
            <h3 className="text-lg font-serif font-bold text-white mb-3" data-id="element-240" data-mp="1qac930gznvl6">
              How to Give
            </h3>
            <p className="text-white/70 leading-relaxed" data-id="element-241" data-mp="3mcytcofwed8i">
              <span className="text-gold-400 font-medium" data-id="element-242" data-mp="3hffg9ruxs6i5">Venmo:</span> On your
              phone, open Venmo and scan the QR code to give. On a computer,
              click the link below to log in to your Venmo account and give.
              <br data-id="element-243" data-mp="3reegqn5jsvu2" />
              <br data-id="element-244" data-mp="3rduuwvcs1nar" />
              <span className="text-gold-400 font-medium" data-id="element-245" data-mp="3rb8myulz55s0">Cash App:</span> Open
              Cash App on your phone and scan the QR code to give. Cash App
              donations must be made by scanning with your phone.
            </p>
          </motion.div>

          {/* QR Code Cards */}
          <div className="flex flex-col md:flex-row justify-center items-stretch gap-8 mb-16" data-id="element-246" data-mp="3chdomijg2yv2">
            {paymentMethods.map((method, index) => {
            const cardContent = <Card className="h-full bg-dark-700 border-dark-600 overflow-hidden transition-all duration-300 group-hover:border-gold-500/50 group-hover:shadow-lg group-hover:shadow-gold-500/10" data-id="element-247" data-mp="2jy898c1cjfop">
                  <div className="p-6 flex flex-col items-center text-center" data-id="element-248" data-mp="25sof30lgwals">
                    {/* Payment Method Name */}
                    <div className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-bold mb-6" style={{
                  backgroundColor: `${method.color}20`,
                  color: method.color
                }} data-id="element-249" data-mp="2amst23t5hiwd">
                      {method.name}
                    </div>

                    {/* QR Code Image */}
                    <div className="w-full max-w-[280px] aspect-square rounded-xl overflow-hidden bg-white p-3 mb-6 group-hover:scale-[1.02] transition-transform duration-300" data-id="element-250" data-mp="2en2v55dtnp5y">
                      <img src={method.qrImage} alt={`${method.name} QR Code`} className="w-full h-full object-contain rounded-lg" data-id="element-251" data-mp="2jnh2el7lmv2x" />
                    </div>

                    {/* Handle / Info */}
                    {method.handle && <p className="text-white/60 text-sm mb-4" data-id="element-252" data-mp="1jmnblsz8eugg">
                        {method.handle}
                      </p>}

                    {/* CTA */}
                    {method.url ? <div className="w-full py-3 rounded-lg font-medium text-white transition-all duration-300 group-hover:opacity-90" style={{
                  backgroundColor: method.color
                }} data-id="element-253" data-mp="19qaml8emt4s1">
                        Give via {method.name}
                      </div> : <div className="w-full py-3 rounded-lg font-medium text-white/70 bg-dark-600 text-center" data-id="element-254" data-mp="1sepahmtnk2om">
                        Scan QR Code with {method.name}
                      </div>}
                  </div>
                </Card>;
            return <motion.div key={method.name} initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.15
            }} className="w-full md:w-[360px]" data-id="element-255" data-mp="2sp06u3c3f17r" data-mpi={index}>
                  {method.url ? <a href={method.url} target="_blank" rel="noopener noreferrer" className="block group" data-id="element-256" data-mp="3gbyfwfxvv6vn">
                      {cardContent}
                    </a> : <div className="block" data-id="element-257" data-mp="1qzd761jdbgkt">{cardContent}</div>}
                </motion.div>;
          })}
          </div>

          {/* Where Your Money Goes */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark-800 rounded-2xl p-8 md:p-12 border border-dark-600" data-id="element-258" data-mp="1nxi3gn9jo15v">
            <div className="max-w-3xl mx-auto" data-id="element-259" data-mp="26vb8bv3qal5w">
              <div className="flex items-center justify-center mb-8" data-id="element-260" data-mp="26u05pym0rjgd">
                <div className="w-12 h-12 rounded-full bg-gold-500/10 flex items-center justify-center mr-4" data-id="element-261" data-mp="22u96r7mc9x0r">
                  <Heart className="w-6 h-6 text-gold-500" data-id="element-262" data-mp="2gle0xu6xtx3p" />
                </div>
                <h2 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-263" data-mp="2bmb1qqdn2l3n">
                  Where Your Money Goes
                </h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-264" data-mp="2qh7mu46jr2y5">
                {['Podcast Production & Equipment', 'Essential Bags Outreach Program', 'Guest Travel & Support', 'Bookstore & Educational Resources'].map((item, i) => <div key={i} className="flex items-center p-4 bg-dark-700 rounded-xl border border-dark-600" data-id="element-265" data-mp="2v8co3cyri5cm" data-mpi={i}>
                    <div className="w-6 h-6 rounded-full bg-gold-500/20 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-266" data-mp="308qxozg0hncr">
                      <Check className="w-4 h-4 text-gold-500" data-id="element-267" data-mp="2q99tkmgerhiw" />
                    </div>
                    <span className="text-white/80" data-id="element-268" data-mp="2chli8ldzgx2z">{item}</span>
                  </div>)}
              </div>

              <p className="text-center text-white/50 text-sm italic mt-8" data-id="element-269" data-mp="2hfmykyk0yiar">
                3 Doves Podcast is committed to financial transparency. Every
                dollar is used to further the mission of sharing the Gospel and
                serving our community. A 20% administration fee is applied to
                all donations. Please note: 3 Doves Podcast is not a registered
                non-profit organization. Contributions are not tax-deductible.
              </p>
            </div>
          </motion.div>

          {/* How to Pray for the Ministry */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-12 bg-dark-800 rounded-2xl p-8 md:p-12 border border-dark-600" data-id="element-270" data-mp="290qzf6c3qim3">
            <div className="max-w-3xl mx-auto" data-id="element-271" data-mp="1v9c9efjs1h5j">
              <div className="text-center mb-8" data-id="element-272" data-mp="1qaj0l0ffqebp">
                <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-273" data-mp="1q7wk2bakgohc">
                  Pray for the Ministry
                </h2>
                <p className="text-white/60" data-id="element-274" data-mp="1gbjqreixocn4">
                  Your prayers mean just as much as your giving. Here's how you
                  can lift up 3 Doves Podcast in prayer:
                </p>
              </div>

              <ol className="space-y-4" data-id="element-275" data-mp="1b5ocop0ctn9v">
                {['That many will hear the good news of Jesus Christ.', 'Humbleness will always be our banner.', 'Christ will always be our center.', 'Resources will always be available.', 'Jason will continue to meet more and more people that want to share what Jesus has done in and through them.'].map((item, i) => <li key={i} className="flex items-start p-4 bg-dark-700 rounded-xl border border-dark-600" data-id="element-276" data-mp="xfb6os70win6" data-mpi={i}>
                    <span className="w-7 h-7 rounded-full bg-gold-500/20 flex items-center justify-center mr-4 flex-shrink-0 mt-0.5" data-id="element-277" data-mp="4qx8ocfxpmbm">
                      <span className="text-sm font-bold text-gold-500" data-id="element-278" data-mp="9p76yvwyh31g">
                        {i + 1}
                      </span>
                    </span>
                    <span className="text-white/80 leading-relaxed" data-id="element-279" data-mp="1x7gq5u82s656">
                      {item}
                    </span>
                  </li>)}
              </ol>
            </div>
          </motion.div>

          {/* Sponsors */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-12 bg-dark-800 rounded-2xl p-8 md:p-12 border border-dark-600" data-id="element-280" data-mp="2b3kdr4og1g8o">
            <div className="max-w-3xl mx-auto" data-id="element-281" data-mp="1s5rb83hqf8bt">
              <div className="text-center mb-8" data-id="element-282" data-mp="1s7kj1m42zyle">
                <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-283" data-mp="vod4bd3pzy2x">
                  Our Sponsors
                </h2>
                <p className="text-white/60" data-id="element-284" data-mp="zodshpgmfnn6">
                  We're grateful for the businesses that support the mission of
                  3 Doves Podcast.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-285" data-mp="n7ma65u3l9q4">
                {[{
                name: "Horseman's Landscape",
                url: 'https://horsemanslandscape.com'
              }, {
                name: 'First Response Water & Mold Removal',
                url: 'https://firstresponsewaterandmold.com/'
              }, {
                name: 'Chill of Cape Coral',
                url: 'https://www.capechill.net/'
              }].map((sponsor, i) => <a key={i} href={sponsor.url} target="_blank" rel="noopener noreferrer" className="group" data-id="element-286" data-mp="3rmvv3lji7pn5" data-mpi={i}>
                    <div className="flex flex-col items-center justify-center p-6 bg-dark-700 rounded-xl border border-dark-600 hover:border-gold-500/50 transition-all duration-300 h-full text-center" data-id="element-287" data-mp="3hphdvjprawts">
                      <h3 className="text-lg font-serif font-bold text-white mb-3 group-hover:text-gold-400 transition-colors" data-id="element-288" data-mp="3cw9cgy2ockwv">
                        {sponsor.name}
                      </h3>
                      <span className="flex items-center text-sm text-gold-500 gap-1" data-id="element-289" data-mp="3329a33ys1tru">
                        <ExternalLink className="w-3.5 h-3.5" data-id="element-290" data-mp="3qqsev9imbof6" />
                        Visit Website
                      </span>
                    </div>
                  </a>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </PageTransition>;
}